import { getHeaders } from "../utils";
import {v4} from "uuid";
const intKey = process.env.REACT_APP_API_INTERNAL_TOKEN;

export async function APICreateOrderTender(orderId,type,bidData, user) {
	try {
		const headers = getHeaders(intKey);

		const body = {
			createdByUser : user?.id,
			createdByCompany : user?.companyId,
			ordersId : orderId,
			tenderType : type,
			details: bidData,
			companies: bidData.planCreators || []
		};

		const requestOptions = {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(body),
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/tender/1.0/company/${user.companyId}/order/${orderId}`, requestOptions);
		const responseObject = await response.json();
		const tender = responseObject.data;
		return tender;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export async function APIArchiveOrderTender({orderId, companyId}) {
	try {
		const headers = getHeaders(intKey);

		const requestOptions = {
			method: 'DELETE',
			headers: headers,
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/tender/1.0/company/${companyId}/order/${orderId}`, requestOptions);
		const responseObject = await response.json();
		const tender = responseObject.data;
		return tender;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export async function APIGetTenderByOrderId({orderId, companyId}) {
	try {
		const headers = getHeaders(intKey);

		const requestOptions = {
			method: 'GET',
			headers: headers,
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/tender/1.0/company/${companyId}/order/${orderId}`, requestOptions);
		
		if (response.status === 204) {
			return null;
		}

		const responseObject = await response.json();
		const tender = responseObject.data;
		return tender;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export async function APICreateOrderTenderBids(orderId,bid,tenderId,type, user) {

	try {


		const headers = getHeaders(intKey);
		const body = {
			createdByUser : user?.id,
			createdByCompany : user?.companyId,
			tenderId : tenderId,
			bid : bid?.bid,
			bidType : type,
		};

		const requestOptions = {
			method: 'POST',
			headers: headers,
			body: JSON.stringify(body),
			redirect: 'follow'
		};


		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/bids/1.0/company/${user.companyId}/order/${orderId}/tender/${tenderId}`, requestOptions);
		const responseObject = await response.json();
		const orderTenderBids = responseObject.data;

		return orderTenderBids;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export async function APIUpdateOrderTenderBids(orderId,bid,tenderId,type, orderTenderBidsId, user) {
	if(orderTenderBidsId !== null) {
		try {
			const headers = getHeaders(intKey);

			const body = {
				createdByUser : user?.id,
				createdByCompany : user?.companyId,
				tenderId : tenderId,
				bid : bid,
				bidType : type,
			};

			const requestOptions = {
				method: 'PUT',
				headers: headers,
				body: JSON.stringify(body),
				redirect: 'follow'
			};


			// Use template literals to construct the URL
			const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
			const response = await fetch(`${apiUrl}/bids/1.0/company/${user.companyId}/order/${orderId}/tender/${tenderId}/bid/${orderTenderBidsId}`, requestOptions);
			const responseObject = await response.json();
			const orderTenderBids = responseObject.data;



			return orderTenderBids;

		} catch (error) {
			console.error('Error:', error);
			throw error;
		}
	} else {
		console.error("No orderTenderBidsId given")
	}

}

export async function APIDeleteOrderTenderBids({orderId, tenderId, orderTenderBidsId, companyId}) {

	if(orderTenderBidsId !== null) {
		try {
			const headers = getHeaders(intKey);

			const requestOptions = {
				method: 'DELETE',
				headers: headers,
				redirect: 'follow'
			};

			// Use template literals to construct the URL
			const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
			await fetch(`${apiUrl}/bids/1.0/company/${companyId}/order/${orderId}/tender/${tenderId}/bid/${orderTenderBidsId}`, requestOptions);
			return;

		} catch (error) {
			console.error('Error:', error);
			throw error;
		}
	} else {
		console.error("No orderTenderBidsId given")
	}

}

export async function APIGetOrderTenderBidsByCompany(orderId,tenderId, user) {
	try {
		const headers = getHeaders(intKey);

		const requestOptions = {
			method: 'GET',
			headers: headers,
			redirect: 'follow'
		};


		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/bids/1.0/company/${user.companyId}/order/${orderId}/tender/${tenderId}/my`, requestOptions);
		const responseObject = await response?.json();
		const orderTenderBids = responseObject.data;
		return orderTenderBids;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}

export async function APIGetOrderTenderBidsByOrderId({orderId, tenderId, companyId}) {
	try {
		const headers = getHeaders(intKey);

		const requestOptions = {
			method: 'GET',
			headers: headers,
			redirect: 'follow'
		};

		// Use template literals to construct the URL
		const apiUrl = process.env.REACT_APP_MODE === 'PROD' ? process.env.REACT_APP_API_INTERNAL_PRODUCTION : process.env.REACT_APP_API_INTERNAL_DEVELOPMENT;
		const response = await fetch(`${apiUrl}/bids/1.0/company/${companyId}/order/${orderId}/tender/${tenderId}`, requestOptions);
		const responseObject = await response?.json();
		const orderTenderBids = responseObject.data;
		return orderTenderBids;

	} catch (error) {
		console.error('Error:', error);
		throw error;
	}
}
